import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/svgs/icons/message-preview.svg';
const _withScopeId = n => (_pushScopeId("data-v-57bb884d"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "campaigns-dynamic-table" };
const _hoisted_2 = { class: "campaigns-dynamic-table__empty" };
const _hoisted_3 = ["src"];
const _hoisted_4 = { class: "campaigns-dynamic-table__empty-text" };
const _hoisted_5 = { class: "campaigns-dynamic-table__header" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-question-12px el-tooltip__trigger campaigns-dynamic-table__tooltip-icon" }, null, -1));
const _hoisted_7 = {
    key: 0,
    class: "status-cell"
};
const _hoisted_8 = { class: "status-cell" };
const _hoisted_9 = {
    key: 1,
    class: "status-cell"
};
const _hoisted_10 = { key: 1 };
const _hoisted_11 = ["alt", "onClick"];
const _hoisted_12 = {
    key: 2,
    class: "campaign-name-cell"
};
const _hoisted_13 = { class: "campaign-name-cell__text" };
const _hoisted_14 = {
    key: 1,
    class: "campaign-name-cell__text"
};
const _hoisted_15 = { key: 3 };
const _hoisted_16 = {
    key: 4,
    class: "base-people-cell"
};
const _hoisted_17 = { key: 5 };
const _hoisted_18 = ["aria-label"];
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-menu-14px" }, null, -1));
const _hoisted_20 = [
    _hoisted_19
];
import { computed, reactive } from 'vue';
import ListPagination from '@/components/_atoms/ListPagination.vue';
import TableColumnSearch from '@/components/TableColumnSearch.vue';
import CampaignsDynamicTableSkeleton from './CampaignsDynamicTableSkeleton.vue';
import { can, METRIC_COLUMN_MIN_WIDTHS } from '@/features/CampaignsEmail/services/utils';
import emptyIcon from '@/assets/svgs/EmptyListCampaigns.svg';
import { getCampaignStatus } from '../utils/campaignStatus';
export default /*#__PURE__*/ _defineComponent({
    __name: 'CampaignsDynamicTable',
    props: {
        columns: {},
        columnMinWidths: {},
        rows: {},
        loading: { type: Boolean },
        page: {},
        limit: {},
        total: {},
        orderBy: {}
    },
    emits: ["change-page", "filters-changed", "preview", "sort-change", "edit", "delete", "finish"],
    setup(__props, { emit }) {
        const props = __props;
        const computedColumnMinWidths = computed(() => ({
            ...METRIC_COLUMN_MIN_WIDTHS,
            ...(props.columnMinWidths ?? {}),
        }));
        const searchableKeys = ['status', 'campaign_name', 'is_recurrent', 'sent_at'];
        const sortableKeys = ['status', 'campaign_name', 'is_recurrent', 'sent_at', 'base_people', 'sent_total'];
        const headerTooltips = {
            base_people: 'breadcrumb.email.campaigns.table.tooltip.base-people',
        };
        const hiddenColumns = new Set(['campaign_id', 'is_deletable', 'is_editable', 'is_finishable']);
        const appliedFilters = reactive({});
        const visibleColumns = computed(() => props.columns.filter(col => !hiddenColumns.has(col.key)));
        const parsedOrderBy = computed(() => {
            const raw = props.orderBy || '';
            if (!raw)
                return undefined;
            const isDesc = raw.startsWith('-');
            const prop = isDesc ? raw.slice(1) : raw;
            const order = isDesc ? 'descending' : 'ascending';
            return { prop, order };
        });
        function isSortable(key) {
            return sortableKeys.includes(key);
        }
        function isSearchable(key) {
            return searchableKeys.includes(key);
        }
        function getMinWidth(key) {
            return computedColumnMinWidths.value[key] ?? 200;
        }
        function getColumnClass(key) {
            if (key === 'base_people')
                return 'campaigns-dynamic-table__col--base-people';
            return '';
        }
        function emitFiltersChanged(payload) {
            emit('filters-changed', payload);
        }
        function emitSortChange(orderBy) {
            emit('sort-change', orderBy);
        }
        function handleSearch(key, value) {
            appliedFilters[key] = value;
            const payload = { ...appliedFilters };
            Object.keys(payload).forEach(k => {
                if (payload[k] === '')
                    delete payload[k];
            });
            emitFiltersChanged(payload);
        }
        function handleClear(key) {
            appliedFilters[key] = '';
            const payload = { ...appliedFilters };
            Object.keys(payload).forEach(k => {
                if (payload[k] === '')
                    delete payload[k];
            });
            emitFiltersChanged(payload);
        }
        function onSortChange({ prop, order }) {
            if (!prop)
                return;
            const next = !order || order === 'ascending' ? prop : `-${prop}`;
            emitSortChange(next);
        }
        function formatDate(d) {
            if (!d)
                return '—';
            const isoLike = d.replace(' ', 'T');
            const date = new Date(isoLike);
            if (Number.isNaN(date.getTime()))
                return '—';
            const pad2 = (n) => String(n).padStart(2, '0');
            return [
                pad2(date.getDate()),
                '/',
                pad2(date.getMonth() + 1),
                '/',
                date.getFullYear(),
                ' ',
                pad2(date.getHours()),
                ':',
                pad2(date.getMinutes()),
            ].join('');
        }
        function getStatusDotStyle(status) {
            const key = (status ?? '').toString().trim().toLowerCase();
            if (key === 'programada' || key === 'agendada') {
                return {
                    backgroundColor: '#FFFFFF',
                    border: '2px solid #6C90F4',
                    boxSizing: 'border-box',
                };
            }
            return {
                backgroundColor: getCampaignStatus(status ?? '').dotColor,
                border: 'none',
            };
        }
        function getStatusLabel(status) {
            return getCampaignStatus(status ?? '').label;
        }
        return (_ctx, _cache) => {
            const _component_el_tooltip = _resolveComponent("el-tooltip");
            const _component_el_table_column = _resolveComponent("el-table-column");
            const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
            const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
            const _component_el_dropdown = _resolveComponent("el-dropdown");
            const _component_el_table = _resolveComponent("el-table");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_ctx.loading)
                    ? (_openBlock(), _createBlock(CampaignsDynamicTableSkeleton, { key: 0 }))
                    : (_openBlock(), _createBlock(_component_el_table, {
                        key: 1,
                        data: _ctx.rows,
                        "empty-text": _ctx.$t('is-empty-message'),
                        "default-sort": parsedOrderBy.value,
                        "table-layout": "auto",
                        "min-height": "400",
                        "max-height": "3000",
                        onSortChange: onSortChange
                    }, {
                        empty: _withCtx(() => [
                            _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("img", {
                                    src: _unref(emptyIcon),
                                    alt: "",
                                    width: "80",
                                    height: "80"
                                }, null, 8, _hoisted_3),
                                _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('is-empty-message')), 1)
                            ])
                        ]),
                        default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleColumns.value, (col) => {
                                return (_openBlock(), _createBlock(_component_el_table_column, {
                                    key: col.key,
                                    prop: col.key,
                                    label: col.label,
                                    "min-width": getMinWidth(col.key),
                                    sortable: isSortable(col.key) ? 'custom' : false,
                                    "class-name": getColumnClass(col.key)
                                }, {
                                    header: _withCtx(({ column }) => [
                                        _createElementVNode("span", _hoisted_5, _toDisplayString(column.label), 1),
                                        (isSearchable(col.key))
                                            ? (_openBlock(), _createBlock(TableColumnSearch, {
                                                key: 0,
                                                searchTerm: appliedFilters[col.key] || '',
                                                "onUpdate:nameSearch": value => handleSearch(col.key, value),
                                                "onClear:nameSearch": () => handleClear(col.key)
                                            }, {
                                                reference: _withCtx(() => [
                                                    _createElementVNode("i", {
                                                        class: _normalizeClass(["icon icon-search-12px campaigns-dynamic-table__search-icon", { 'search-icon--active': appliedFilters[col.key] }])
                                                    }, null, 2)
                                                ]),
                                                _: 2
                                            }, 1032, ["searchTerm", "onUpdate:nameSearch", "onClear:nameSearch"]))
                                            : _createCommentVNode("", true),
                                        (headerTooltips[col.key])
                                            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                                key: 1,
                                                content: _ctx.$t(headerTooltips[col.key]),
                                                placement: "top"
                                            }, {
                                                default: _withCtx(() => [
                                                    _hoisted_6
                                                ]),
                                                _: 2
                                            }, 1032, ["content"]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    default: _withCtx(({ row }) => [
                                        (col.key === 'status')
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                                                (row.status)
                                                    ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                                        key: 0,
                                                        content: _ctx.$t(_unref(getCampaignStatus)(row.status).tip),
                                                        placement: "top"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createElementVNode("span", _hoisted_8, [
                                                                _createElementVNode("span", {
                                                                    class: "status-dot",
                                                                    style: _normalizeStyle(getStatusDotStyle(row.status))
                                                                }, null, 4),
                                                                _createTextVNode(" " + _toDisplayString(getStatusLabel(row.status)), 1)
                                                            ])
                                                        ]),
                                                        _: 2
                                                    }, 1032, ["content"]))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_9, [
                                                        _createElementVNode("span", {
                                                            class: "status-dot",
                                                            style: _normalizeStyle(getStatusDotStyle(undefined))
                                                        }, null, 4),
                                                        _createTextVNode(" " + _toDisplayString(getStatusLabel(undefined)), 1)
                                                    ]))
                                            ]))
                                            : (col.key === 'template')
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                                                    _createElementVNode("img", {
                                                        src: _imports_0,
                                                        alt: _ctx.$t('breadcrumb.email.campaigns.table.preview-alt'),
                                                        class: "icon-button",
                                                        onClick: ($event) => (_ctx.$emit('preview', row))
                                                    }, null, 8, _hoisted_11)
                                                ]))
                                                : (col.key === 'campaign_name')
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                                                        (row[col.key])
                                                            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                                                key: 0,
                                                                content: String(row[col.key]),
                                                                placement: "top"
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createElementVNode("span", _hoisted_13, _toDisplayString(row[col.key]), 1)
                                                                ]),
                                                                _: 2
                                                            }, 1032, ["content"]))
                                                            : (_openBlock(), _createElementBlock("span", _hoisted_14, "—"))
                                                    ]))
                                                    : (col.key === 'sent_at')
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(formatDate(row.sent_at)), 1))
                                                        : (col.key === 'base_people')
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(row[col.key] ?? '—'), 1))
                                                            : (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(row[col.key] ?? '—'), 1))
                                    ]),
                                    _: 2
                                }, 1032, ["prop", "label", "min-width", "sortable", "class-name"]));
                            }), 128)),
                            _createVNode(_component_el_table_column, { width: "56" }, {
                                default: _withCtx(({ row }) => [
                                    (_unref(can)(row, 'edit') || _unref(can)(row, 'delete') || _unref(can)(row, 'finish'))
                                        ? (_openBlock(), _createBlock(_component_el_dropdown, {
                                            key: 0,
                                            trigger: "click",
                                            class: "campaigns-dynamic-table__dropdown"
                                        }, {
                                            dropdown: _withCtx(() => [
                                                _createVNode(_component_el_dropdown_menu, null, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_el_dropdown_item, {
                                                            onClick: ($event) => (_ctx.$emit('edit', row)),
                                                            disabled: !_unref(can)(row, 'edit')
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(_ctx.$t('edit')), 1)
                                                            ]),
                                                            _: 2
                                                        }, 1032, ["onClick", "disabled"]),
                                                        _createVNode(_component_el_dropdown_item, {
                                                            onClick: ($event) => (_ctx.$emit('delete', row)),
                                                            disabled: !_unref(can)(row, 'delete')
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(_ctx.$t('delete')), 1)
                                                            ]),
                                                            _: 2
                                                        }, 1032, ["onClick", "disabled"]),
                                                        _createVNode(_component_el_dropdown_item, {
                                                            onClick: ($event) => (_ctx.$emit('finish', row)),
                                                            disabled: !_unref(can)(row, 'finish')
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(_ctx.$t('breadcrumb.email.campaigns.table.actions.finish')), 1)
                                                            ]),
                                                            _: 2
                                                        }, 1032, ["onClick", "disabled"])
                                                    ]),
                                                    _: 2
                                                }, 1024)
                                            ]),
                                            default: _withCtx(() => [
                                                _createElementVNode("span", {
                                                    class: "campaigns-dynamic-table__dropdown__button",
                                                    role: "button",
                                                    "aria-label": _ctx.$t('breadcrumb.email.campaigns.table.aria.more-actions')
                                                }, _hoisted_20, 8, _hoisted_18)
                                            ]),
                                            _: 2
                                        }, 1024))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }, 8, ["data", "empty-text", "default-sort"])),
                _createVNode(ListPagination, {
                    data: { page: _ctx.page, limit: _ctx.limit, count: _ctx.total, size: 5 },
                    "limit-range": [10, 20, 50],
                    identify: "email-campaigns-dyn",
                    "show-list-pages": false,
                    "show-quantity-lines": true,
                    onChangePage: _cache[0] || (_cache[0] = (_, d) => _ctx.$emit('change-page', d))
                }, null, 8, ["data"])
            ]));
        };
    }
});
